/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AssignedPackageModelPagedResult } from '../models/assigned-package-model-paged-result';
import { CarrierPackageModelPagedResult } from '../models/carrier-package-model-paged-result';
import { DeliverPackageCommand } from '../models/deliver-package-command';
import { DispatchedPackageModelPagedResult } from '../models/dispatched-package-model-paged-result';
import { PackageDetailModel } from '../models/package-detail-model';
import { PackageLookupModel } from '../models/package-lookup-model';
import { PackagesOrderByProperty } from '../models/packages-order-by-property';
import { PickUpPackageCommand } from '../models/pick-up-package-command';
import { RefusePackageCommand } from '../models/refuse-package-command';
import { StartScanFlowModel } from '../models/start-scan-flow-model';
import { TransferPackageCommand } from '../models/transfer-package-command';

@Injectable({
  providedIn: 'root',
})
export class PackagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation getDispatchedPackages
   */
  static readonly GetDispatchedPackagesPath = '/api/packages/dispatched';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDispatchedPackages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDispatchedPackages$Response(params?: {
    orderBy?: PackagesOrderByProperty;
    searchQuery?: string;
    skip?: number;
    take?: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<DispatchedPackageModelPagedResult>> {
    const rb = new RequestBuilder(this.rootUrl, PackagesService.GetDispatchedPackagesPath, 'get');
    if (params) {
      rb.query('orderBy', params.orderBy, { style: 'form' });
      rb.query('searchQuery', params.searchQuery, { style: 'form' });
      rb.query('skip', params.skip, { style: 'form' });
      rb.query('take', params.take, { style: 'form' });
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<DispatchedPackageModelPagedResult>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDispatchedPackages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDispatchedPackages(params?: {
    orderBy?: PackagesOrderByProperty;
    searchQuery?: string;
    skip?: number;
    take?: number;
    context?: HttpContext;
  }): Observable<DispatchedPackageModelPagedResult> {
    return this.getDispatchedPackages$Response(params).pipe(
      map((r: StrictHttpResponse<DispatchedPackageModelPagedResult>) => r.body as DispatchedPackageModelPagedResult),
    );
  }

  /**
   * Path part for operation getAssignedPackages
   */
  static readonly GetAssignedPackagesPath = '/api/packages/assigned';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAssignedPackages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssignedPackages$Response(params?: {
    orderBy?: PackagesOrderByProperty;
    searchQuery?: string;
    skip?: number;
    take?: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<AssignedPackageModelPagedResult>> {
    const rb = new RequestBuilder(this.rootUrl, PackagesService.GetAssignedPackagesPath, 'get');
    if (params) {
      rb.query('orderBy', params.orderBy, { style: 'form' });
      rb.query('searchQuery', params.searchQuery, { style: 'form' });
      rb.query('skip', params.skip, { style: 'form' });
      rb.query('take', params.take, { style: 'form' });
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<AssignedPackageModelPagedResult>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAssignedPackages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssignedPackages(params?: {
    orderBy?: PackagesOrderByProperty;
    searchQuery?: string;
    skip?: number;
    take?: number;
    context?: HttpContext;
  }): Observable<AssignedPackageModelPagedResult> {
    return this.getAssignedPackages$Response(params).pipe(
      map((r: StrictHttpResponse<AssignedPackageModelPagedResult>) => r.body as AssignedPackageModelPagedResult),
    );
  }

  /**
   * Path part for operation getCarrierPackages
   */
  static readonly GetCarrierPackagesPath = '/api/packages/carrier';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierPackages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierPackages$Response(params?: {
    orderBy?: PackagesOrderByProperty;
    searchQuery?: string;
    delivered?: boolean;
    skip?: number;
    take?: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<CarrierPackageModelPagedResult>> {
    const rb = new RequestBuilder(this.rootUrl, PackagesService.GetCarrierPackagesPath, 'get');
    if (params) {
      rb.query('orderBy', params.orderBy, { style: 'form' });
      rb.query('searchQuery', params.searchQuery, { style: 'form' });
      rb.query('delivered', params.delivered, { style: 'form' });
      rb.query('skip', params.skip, { style: 'form' });
      rb.query('take', params.take, { style: 'form' });
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CarrierPackageModelPagedResult>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCarrierPackages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierPackages(params?: {
    orderBy?: PackagesOrderByProperty;
    searchQuery?: string;
    delivered?: boolean;
    skip?: number;
    take?: number;
    context?: HttpContext;
  }): Observable<CarrierPackageModelPagedResult> {
    return this.getCarrierPackages$Response(params).pipe(
      map((r: StrictHttpResponse<CarrierPackageModelPagedResult>) => r.body as CarrierPackageModelPagedResult),
    );
  }

  /**
   * Path part for operation lookupPackage
   */
  static readonly LookupPackagePath = '/api/packages/lookup/{ddtCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lookupPackage()` instead.
   *
   * This method doesn't expect any request body.
   */
  lookupPackage$Response(params: { ddtCode: string; context?: HttpContext }): Observable<StrictHttpResponse<PackageLookupModel>> {
    const rb = new RequestBuilder(this.rootUrl, PackagesService.LookupPackagePath, 'get');
    if (params) {
      rb.path('ddtCode', params.ddtCode, { style: 'simple' });
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<PackageLookupModel>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `lookupPackage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lookupPackage(params: { ddtCode: string; context?: HttpContext }): Observable<PackageLookupModel> {
    return this.lookupPackage$Response(params).pipe(map((r: StrictHttpResponse<PackageLookupModel>) => r.body as PackageLookupModel));
  }

  /**
   * Path part for operation getPackageDetail
   */
  static readonly GetPackageDetailPath = '/api/packages/{ddtCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPackageDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackageDetail$Response(params: { ddtCode: string; context?: HttpContext }): Observable<StrictHttpResponse<PackageDetailModel>> {
    const rb = new RequestBuilder(this.rootUrl, PackagesService.GetPackageDetailPath, 'get');
    if (params) {
      rb.path('ddtCode', params.ddtCode, { style: 'simple' });
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<PackageDetailModel>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPackageDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackageDetail(params: { ddtCode: string; context?: HttpContext }): Observable<PackageDetailModel> {
    return this.getPackageDetail$Response(params).pipe(map((r: StrictHttpResponse<PackageDetailModel>) => r.body as PackageDetailModel));
  }

  /**
   * Path part for operation pickUpPackage
   */
  static readonly PickUpPackagePath = '/api/packages/pick-up';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickUpPackage()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pickUpPackage$Response(params?: { context?: HttpContext; body?: PickUpPackageCommand }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, PackagesService.PickUpPackagePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pickUpPackage$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pickUpPackage(params?: { context?: HttpContext; body?: PickUpPackageCommand }): Observable<void> {
    return this.pickUpPackage$Response(params).pipe(map((r: StrictHttpResponse<void>) => r.body as void));
  }

  /**
   * Path part for operation startOperationFlow
   */
  static readonly StartOperationFlowPath = '/api/packages/start';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startOperationFlow$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  startOperationFlow$Plain$Response(params?: { context?: HttpContext }): Observable<StrictHttpResponse<StartScanFlowModel>> {
    const rb = new RequestBuilder(this.rootUrl, PackagesService.StartOperationFlowPath, 'post');
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: 'text/plain',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<StartScanFlowModel>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `startOperationFlow$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  startOperationFlow$Plain(params?: { context?: HttpContext }): Observable<StartScanFlowModel> {
    return this.startOperationFlow$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StartScanFlowModel>) => r.body as StartScanFlowModel),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startOperationFlow()` instead.
   *
   * This method doesn't expect any request body.
   */
  startOperationFlow$Response(params?: { context?: HttpContext }): Observable<StrictHttpResponse<StartScanFlowModel>> {
    const rb = new RequestBuilder(this.rootUrl, PackagesService.StartOperationFlowPath, 'post');
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'text/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<StartScanFlowModel>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `startOperationFlow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  startOperationFlow(params?: { context?: HttpContext }): Observable<StartScanFlowModel> {
    return this.startOperationFlow$Response(params).pipe(map((r: StrictHttpResponse<StartScanFlowModel>) => r.body as StartScanFlowModel));
  }

  /**
   * Path part for operation transferPackage
   */
  static readonly TransferPackagePath = '/api/packages/{ddtCode}/transfer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transferPackage()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  transferPackage$Response(params: {
    ddtCode: string;
    context?: HttpContext;
    body?: TransferPackageCommand;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, PackagesService.TransferPackagePath, 'put');
    if (params) {
      rb.path('ddtCode', params.ddtCode, { style: 'simple' });
      rb.body(params.body, 'application/*+json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transferPackage$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  transferPackage(params: { ddtCode: string; context?: HttpContext; body?: TransferPackageCommand }): Observable<void> {
    return this.transferPackage$Response(params).pipe(map((r: StrictHttpResponse<void>) => r.body as void));
  }

  /**
   * Path part for operation deliverPackage
   */
  static readonly DeliverPackagePath = '/api/packages/{ddtCode}/deliver';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliverPackage()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deliverPackage$Response(params: {
    ddtCode: string;
    context?: HttpContext;
    body?: DeliverPackageCommand;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, PackagesService.DeliverPackagePath, 'put');
    if (params) {
      rb.path('ddtCode', params.ddtCode, { style: 'simple' });
      rb.body(params.body, 'application/*+json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deliverPackage$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deliverPackage(params: { ddtCode: string; context?: HttpContext; body?: DeliverPackageCommand }): Observable<void> {
    return this.deliverPackage$Response(params).pipe(map((r: StrictHttpResponse<void>) => r.body as void));
  }

  /**
   * Path part for operation refusePackage
   */
  static readonly RefusePackagePath = '/api/packages/{ddtCode}/refuse';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refusePackage()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  refusePackage$Response(params: {
    ddtCode: string;
    context?: HttpContext;
    body?: RefusePackageCommand;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, PackagesService.RefusePackagePath, 'put');
    if (params) {
      rb.path('ddtCode', params.ddtCode, { style: 'simple' });
      rb.body(params.body, 'application/*+json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `refusePackage$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  refusePackage(params: { ddtCode: string; context?: HttpContext; body?: RefusePackageCommand }): Observable<void> {
    return this.refusePackage$Response(params).pipe(map((r: StrictHttpResponse<void>) => r.body as void));
  }
}
